import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/views/Layout.vue';
import Auth from '@/views/Auth.vue';
// import Register from '@/views/Register.vue';
import store from '../store';

import error404 from '../views/Errors/404.vue';
import Account from '../views/Account.vue';
import Contact from '../views/Contact.vue';
import NewPassword from '../views/NewPassword.vue';
import Reports from '../views/Reports.vue';
import Dashboard from '../views/Dashboard.vue';


Vue.use(VueRouter);

const routes = [
    {path: '/404', name: '404', component: error404, meta: {title: '404 - not found', rule: 'isPublic'}},
    {
        path: '/',
        component: Layout,
        children: [
            {path: '', name: 'dashboard', component: Dashboard, meta: {title: 'Dashboard', rule: 'isLogged'}},
            {path: '/login', name: 'login', component: Auth, meta: {rule: 'isPublic'}},
            // {path: '/register', name: 'register', component: Register, meta: {rule: 'isPublic'}},
            {path: '/contact', name: 'contact', component: Contact, meta: {rule: 'isLogged'}},
            {path: '/reports', name: 'reports', component: Reports, meta: {title: 'Dynamic reports', rule: 'isLogged'}},
            {path: '/account', name: 'account', component: Account, meta: {title: 'Account settings', rule: 'isLogged'}},
            {path: '/new-password', name: 'new_password', component: NewPassword, meta: {title: 'Change account password', rule: 'isLogged'}},
        ]
    },
    {path: '*', component: error404, meta: {title: '404 - not found'}},
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta) {
        store.commit('setMeta', to.meta);
        if (to.meta.title) {
            document.title = `Genie | ${to.meta.title}`;
        } else {
            document.title = 'Genie';
        }
    }
    if (store.state.force_new_pass && to.name !== 'new_password' && to.meta.rule === 'isLogged') {
        next({name: 'new_password'})
    } else {
        next();
    }
});

export default router;
